import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../auth.service';
import { TokenManager } from '../tokens/token-manager';
import { UserService } from '../user.service';

const redirectLogin = (state: RouterStateSnapshot): void => {
  const authService = inject(AuthService);
  const router = inject(Router);

  authService.logout(false);

  router.navigate(['/auth/login'], { replaceUrl: true });
};

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const userService = inject(UserService);
  let usuarioActivo: any | null = null;


  const isOutOfDate = TokenManager.isExpired();
   userService.usuarioActivo$.subscribe((data)=>{
    usuarioActivo = data;
   });
  try {
    if (isOutOfDate || !usuarioActivo) {
      redirectLogin(state);
      return false;
    }
  } catch {
    redirectLogin(state);
    return false;
  }
  return true;
};
